import {
  AbutmentTypeEnum,
  RetentionTypeEnum,
  type AbutmentCharacteristics,
  type AbutmentType,
  type CustomAbutmentCharacteristics,
  type ImplantCharacteristics,
  type ReferencedImplantCharacteristics,
  type RetentionType,
  type StandardAbutmentCharacteristics,
  type UnreferencedImplantCharacteristics,
} from "./implants.types";

export const isReferencedImplantCharacteristics = (
  characteristics: ImplantCharacteristics
): characteristics is ReferencedImplantCharacteristics =>
  "implantReferenceId" in characteristics &&
  !!characteristics.implantReferenceId;

export const isUnreferencedImplantCharacteristics = (
  characteristics: ImplantCharacteristics
): characteristics is UnreferencedImplantCharacteristics =>
  "implantBrand" in characteristics &&
  "implantSystem" in characteristics &&
  (!!characteristics.implantBrand || !!characteristics.implantSystem);

export const isPartialReferencedImplantCharacteristics = (
  characteristics: Partial<ImplantCharacteristics>
): characteristics is Partial<ReferencedImplantCharacteristics> =>
  isReferencedImplantCharacteristics(characteristics as ImplantCharacteristics);

export const isPartialUnreferencedImplantCharacteristics = (
  characteristics: Partial<ImplantCharacteristics>
): characteristics is Partial<UnreferencedImplantCharacteristics> =>
  isUnreferencedImplantCharacteristics(
    characteristics as ImplantCharacteristics
  );

export const isStandardAbutmentCharacteristics = (
  characteristics: AbutmentCharacteristics
): characteristics is StandardAbutmentCharacteristics =>
  characteristics.abutmentType === AbutmentTypeEnum.STANDARD ||
  characteristics.abutmentType === AbutmentTypeEnum.STANDARD_GENERIC;

export const isCustomAbutmentCharacteristics = (
  characteristics: AbutmentCharacteristics
): characteristics is CustomAbutmentCharacteristics =>
  characteristics.abutmentType === AbutmentTypeEnum.CUSTOM;

export const isPartialStandardAbutmentCharacteristics = (
  characteristics: Partial<AbutmentCharacteristics>
): characteristics is Partial<StandardAbutmentCharacteristics> =>
  isStandardAbutmentCharacteristics(characteristics as AbutmentCharacteristics);

export const isPartialCustomAbutmentCharacteristics = (
  characteristics: Partial<AbutmentCharacteristics>
): characteristics is Partial<CustomAbutmentCharacteristics> =>
  isCustomAbutmentCharacteristics(characteristics as AbutmentCharacteristics);

export const isValidAbutmentType = (value: string): value is AbutmentType =>
  Object.values(AbutmentTypeEnum).includes(value as AbutmentType);

export const isValidRetentionType = (value: string): value is RetentionType =>
  Object.values(RetentionTypeEnum).includes(value as RetentionType);
